import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import { firmwareTypes } from 'appConstants';
import { Select } from 'antd';
import style from './FirmwareTypeSelect.module.scss';

const { Option } = Select;

const FirmwareTypeSelect: React.FC = () => {
	const { changeTypeFirmware, IDSelectedTypeFirmware } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<div className={style.container} data-test="FirmwareTypeSelect">
			<Text translationNameSpace="listing" translationKey="firmwareTypeLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={changeTypeFirmware}
				value={IDSelectedTypeFirmware}
				listItemHeight={firmwareTypes.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				{firmwareTypes.length ? (
					<>
						<Option value={null}>
							<Text translationNameSpace="listing" translationKey="allTypesLabel" asFragment={true} />
						</Option>
						{firmwareTypes.map((el) => (
							<Option className={style.listItem} value={el.firmwareTypeID} key={el.firmwareTypeID}>
								{el.firmwareTypeName}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default FirmwareTypeSelect;
